<template>
    <div class="flex-grow-1">
        <div class="d-flex align-items-center">

            <div class="d-flex flex-column mr-3">
                <div>
                    <div class="d-flex">
                        <div class="mr-1">
                            Title:
                        </div>
                        <div>
                            <span v-if="item.title">
                                <strong>{{item.title}}</strong>
                            </span>
                            <span v-else class="text-muted">
                                no title
                            </span>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="mr-1">
                            Printable ID:
                        </div>
                        <div>
                            <span>
                                <strong>{{item.id}}</strong>
                            </span>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="mr-1">
                            Merlin ID:
                        </div>
                        <div>
                            <span v-if="item.dam_id">
                                <strong>{{item.dam_id}}</strong>
                            </span>
                            <span v-else class="text-muted">
                                No Merlin ID
                            </span>
                        </div>
                    </div>

                    <div v-if="item.cdn_url" class="d-flex">
                        <div class="mr-1">
                            Source:
                        </div>
                        <div>
                            <strong>
                                <a :href="item.cdn_url" target="_blank" class="item-url">{{item.cdn_url}}</a>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ml-auto">
                <div class="text-nowrap">
                    <span v-if="itemLinked(item)">
                        <b-link class="text-warning" href="#" @click.prevent="unlinkItem(item)">
                            <font-awesome-icon :icon="['fad', 'unlink']" />
                        </b-link>
                    </span>
                    <span v-else>
                        <span v-if="item.linking">
                            <b-spinner small label="Loading..."></b-spinner>
                        </span>
                        <span v-else>
                            <b-link class="text-primary" href="#" @click.prevent="linkItem(item)">
                                <span v-if="article_related_media">
                                    <font-awesome-icon :icon="['fad', 'link']" />
                                </span>
                                <span v-else>
                                    <font-awesome-icon :icon="['fad', 'plus-square']" />
                                </span>
                            </b-link>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.thumbnail {
    width: 100px;
}

.item-url {
    word-break: break-all;
}

.item-description {
    max-height: 150px;
    overflow: scroll;
    word-break: break-word;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({

    }),
    props: [
        'publication',
        'item',
        'article_related_media',
        'file_extensions'
    ],
    components: {},
    computed: {
        ...mapState({

        }),
        media_type () {
            let media_type = null

            if (
                this.item &&
                this.item.type
            ) {
                media_type = this.item.type.toLowerCase()
            }

            return media_type
        },
        thumbnail () {
            let thumbnail = null

            if (
                this.item &&
                this.item.splash_url
            ) {
                thumbnail = this.item.splash_url
            } else {
                thumbnail = this.item.cdn_url
            }

            return thumbnail
        }
    },
    methods: {
        linkItem (item) {
            this.$emit('link', item)
        },
        unlinkItem (item) {
            this.$emit('unlink', item)
        },
        itemLinked (item) {
            let itemLinked = false
            if (
                this.article_related_media &&
                this.article_related_media.length
            ) {
                _.forEach(this.article_related_media, media_item => {
                    if (
                        media_item.pivot &&
                        media_item.pivot.publication_id &&
                        media_item.pivot.publication_id == this.publication.id
                    ) {
                        if (item.dam_id && (item.dam_id == media_item.dam_id)) {
                            itemLinked = true
                        } else if (item.media_id && (item.media_id == media_item.media_id)) {
                            itemLinked = true
                        } else if (item.id == media_item.id) {
                            itemLinked = true
                        }
                    }
                })
            }

            return itemLinked
        }
    }
}
</script>
